module.exports = __webpack_public_path__ + "media/images/background_02-bd846de0df67ffe51c497edf77a52f69.jpg";